import { PayloadAction, createSlice } from '@reduxjs/toolkit'
export interface SearchItemState {
    readonly SearchTermParty: string;
    readonly SearchTermCandidate: string;
    readonly SearchTermCSCandidate: string;
    readonly SearchTermElection: string;
    readonly SearchTermVoter: string;
}

const searchSlice = createSlice({
    name: 'SLICE_search',
    initialState: {
        SearchTermCandidate: '',
        SearchTermCSCandidate: '',
        SearchTermElection: '',
        SearchTermParty: '',
        SearchTermVoter: '',
    } as SearchItemState,
    reducers: {
        candidateSearched(state, action: PayloadAction<string>) {
            state.SearchTermParty = action.payload;
        },
        csCandidateSearched(state, action: PayloadAction<string>) {
            state.SearchTermCSCandidate = action.payload;
        },
        partySearched(state, action: PayloadAction<string>) {
            state.SearchTermParty = action.payload;
        },
        electionSearched(state, action: PayloadAction<string>) {
            state.SearchTermElection = action.payload;
        },
        voterSearched(state, action: PayloadAction<string>) {
            state.SearchTermVoter = action.payload;
        },
    },
})

export const { candidateSearched, csCandidateSearched, partySearched, electionSearched, voterSearched } = searchSlice.actions

export default searchSlice.reducer
